/* eslint-disable max-len */
import { fetchBaseQuery,createApi } from "@reduxjs/toolkit/query/react"
import { baseURL } from "../config"
import { authHeader } from "../CommonMethods/Auth-Headers"
import { CheckUserStatus } from "../CommonMethods/CheckUserStatus"
import SystemConfigCall from "../CommonMethods/SystemConfigCall"




async function myCustomBaseQuery(args, api, extraOptions) {
    //const dispatch=useDispatch()
    // Call your function before making the API call
    const status=await CheckUserStatus()

    if (!status) {

        return;
    }
    // Customize the query options based on the pre-API call data if needed
    
  
    // Proceed with the API call using fetchBaseQuery
    return fetchBaseQuery({ 
        baseUrl: baseURL,
        prepareHeaders:async(headers,{getState})=>{
            const header = await authHeader()
            headers.set('authorization',header.Authorization)
            return headers
        },

    })(args, api, extraOptions)
    
    
}
  
const headers = authHeader()
export const usersList = createApi({
    
    reducerPath: 'usersList',
    baseQuery:myCustomBaseQuery,
 
    tagTypes:['User','History'],
    
    
    endpoints: (builder) => ({

        getSystemConfigData: builder.query({
            query: () =>`system-configuration/`,

            
        }),
       
        getUsers: builder.query({
            query: (searchParams) => `users?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'User',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'User', id:_id}))
            ]:[]

            
        }),
        getUser:builder.query({
            query:(id)=>`/users/${id}`,
            
            providesTags: (result, error, arg) => [{ type: 'User', id: arg }],
            invalidatesTags:['History']
        }),
        addUser:builder.mutation({
            query:user=>({
                url:`users`,
                method:'POST',
                body:user
            }),
            invalidatesTags:['User','History']
        }),
        editUser:builder.mutation({
            query:({id,body})=>({
                url:id!==undefined?`/users/${id}`:`/users/`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'User', id: arg.id },'History']
        }),
        exportUsers:builder.mutation({
            query:({sort,columns,dateformat,params})=>{
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url:`users/export-user-list?${queryParams}`,
                    method:'POST',
                    body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone}
                };
            },
        }),
        exportActivityHistory:builder.mutation({
            query:({sort,columns,username,dateformat})=>({
                
                url:`users/export-activity-history?${sort}`,
                method:'POST',
                body:{"columns":columns,"target_user_name":username,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone}
            }),
        }),

        getActivityHistory: builder.query({
            query: (searchParams) => `users/list-changes?${searchParams}`,
            providesTags: ['History']

        }),
        getCorporateOrganization: builder.query({
            query: (searchParams) => `users/list-organizations${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'User',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({organization_id})=>({type:'User', id:organization_id}))
            ]:[],
        }),
        exportCorporateOrgList:builder.mutation({
            query:({queryString,columns})=>({
                url:`users/export-organization-list/${queryString}`,
                method:'POST',
                body:{"columns":columns}
            }),
            invalidatesTags:['History']
        }),
        getAdminOrCorparateExportHistory: builder.query({
            query: (searchParams) => `users/list-export-history${searchParams !== undefined ? `?${searchParams}` : ""}`,
        }), 
        exportUserExportLog:builder.mutation({
            query:({columns,dateformat,username})=>({
                url:`users/export-history`,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone,"target_user":username}
            }),
        }), 
        viewUser:builder.query({
            query:()=>`users/view-profile`,
            
        }),
        updateEmail:builder.mutation({
            query:({id,body})=>({
                url:`users/update-email-address/${id}`,
                method:'POST',
                body:body
            }),
            invalidatesTags:['History']
        }),
        emailVerified:builder.mutation({
            query:({body})=>({
                url:`users/verify-email-address`,
                method:'POST',
                body:body
            }),
            invalidatesTags:['History']
        }),
    }),
    
   
})

export const {useGetSystemConfigDataQuery,
    useLazyGetUsersQuery,
    useGetUsersQuery,
    useGetUserQuery,
    useAddUserMutation,
    useEditUserMutation,
    useGetActivityHistoryQuery,
    useExportUsersMutation,
    useExportActivityHistoryMutation,
    useGetCorporateOrganizationQuery,
    useExportCorporateOrgListMutation,
    useGetAdminOrCorparateExportHistoryQuery,
    useExportUserExportLogMutation,
    useViewUserQuery,
    useUpdateEmailMutation,
    useEmailVerifiedMutation,
    useLazyGetUserQuery
}=usersList





